import { Title } from '@zenterprise-inc/ui';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

import ProgramDownloadCompleteGuide from './ProgramDownloadCompleteGuide';
import ProgramDownloadGuide from './ProgramDownloadGuide';
import ProgramInstallGuideDialog from './ProgramInstallGuideDialog';

import { downloadJointCertificateProgram } from '@/components/tax-refund/common/utils/downloadJointCertificateProgram';
import { CORPORATION_PATHS } from '@/lib/constants/paths';
import { checkJoinCertificateServer } from '@/lib/utils/joint-certificate';

const CorporationInstallJointCertificateContent = () => {
  const router = useRouter();
  const [downloadClicked, setDownloadClicked] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);

  useEffect(() => {
    checkJoinCertificateServer()
      .then(() => {
        router.replace({
          pathname: `${CORPORATION_PATHS.법인공동인증서선택}`,
          query: router.query
        });
      })
      .catch(() => {
        /* nothing to do */
      });
  }, []);

  const downloadFile = () => {
    downloadJointCertificateProgram();

    setDownloadClicked(true);
  };

  const handleClick = () => {
    checkJoinCertificateServer()
      .then(() => {
        router.replace({
          pathname: `${CORPORATION_PATHS.법인공동인증서선택}`,
          query: router.query
        });
      })
      .catch(() => {
        setOpenDialog(true);
      });
  };

  const handleClose = () => {
    setOpenDialog(false);
  };

  return (
    <div className="page-padding flex w-full flex-col">
      <Title.Headline size="large" title={'공동인증서를 불러오기 위해\n필수 프로그램을 설치해주세요'} />

      <div className="pb-[80px]" />

      {downloadClicked ? (
        <ProgramDownloadCompleteGuide handleDownload={downloadFile} handleClick={handleClick} />
      ) : (
        <ProgramDownloadGuide handleDownload={downloadFile} />
      )}

      <ProgramInstallGuideDialog isOpen={openDialog} handleClose={handleClose} />
    </div>
  );
};

export default CorporationInstallJointCertificateContent;
